import { DefaultState } from 'store/types';

export const GET_LODGING_POLICIES_REQUEST = 'GET_LODGING_POLICIES_REQUEST';
export const GET_LODGING_POLICIES_SUCCESS = 'GET_LODGING_POLICIES_SUCCESS';
export const GET_LODGING_POLICIES_FAILURE = 'GET_LODGING_POLICIES_FAILURE';


export interface GetLodgingPoliciesParams {
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
}

export interface GetLodgingPolicyRow {
  id: string;
  policyName: string;
  policy: string;
  associatedProviderNames: string;
  status: string;
}

export interface GetLodgingPoliciesData {
  rows: GetLodgingPolicyRow[];
  totalCount: number;
}

export type GetLodgingPoliciesState = DefaultState & {
  contents?: GetLodgingPoliciesData;
};

interface GetLodgingPoliciesRequest {
  type: typeof GET_LODGING_POLICIES_REQUEST;
}

interface GetLodgingPoliciesSuccess {
  type: typeof GET_LODGING_POLICIES_SUCCESS;
  contents: GetLodgingPoliciesData;
}

interface GetLodgingPoliciesFailure {
  type: typeof GET_LODGING_POLICIES_FAILURE;
}

export type GetLodgingPoliciesActionTypes = GetLodgingPoliciesRequest | GetLodgingPoliciesSuccess | GetLodgingPoliciesFailure;